export interface AnimalGroupAnalyticsResult {
  data: AnimalGroupAnalytics[];
  isAvgTime: boolean;
}

export interface AnimalGroupAnalytics {
  locationId: string;
  locationName: string;
  activities: AnimalActivityAverage[];
}

export interface AnimalActivityAverage {
  type: FloorPlanAreaType;
  value: any;
}

export enum FloorPlanAreaType {
  Unknown = 0,
  Feeder = 1,
  Water = 2,
  Toilet = 3,
  Walking = 4,
  EnrichmentChain = 5,
  EnrichmentRaw = 6
}

export interface AnimalGroupAnalyticsDetailedResult {
  data: AnimalGroupAnalyticDetails[];
}

export interface AnimalGroupAnalyticDetails {
  animalId: string;
  number: string;
  data: AnimalActivityDetails[];
}

export interface AnimalActivityDetails {
  type: FloorPlanAreaType;
  from: Date;
  to: Date;
}
